export default "__VITE_ASSET__5116b6d7__"